import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import {
  getSurfaceBorder,
  getSurfaceColor,
  getThemeTokens,
  radii,
} from '../../../theme/tokens';

export const EntityPanelFrame = ({
  action,
  children,
  title,
}: {
  action?: ReactNode;
  children: ReactNode;
  title: string;
}) => {
  const theme = useTheme();
  const tokens = getThemeTokens(theme);

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: getSurfaceColor(theme, 'raised'),
        border: `1px solid ${getSurfaceBorder(theme)}`,
        borderRadius: `${radii.xl}px`,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minWidth: 0,
        overflow: 'hidden',
        p: { sm: 3, xs: 2.5 },
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          gap: 1.5,
          justifyContent: 'space-between',
          mb: 2.25,
          minWidth: 0,
        }}
      >
        <Typography
          component="h2"
          sx={{
            color: tokens.textPrimary,
            fontSize: 24,
            fontWeight: 800,
            letterSpacing: '-0.02em',
            lineHeight: 1.1,
            minWidth: 0,
          }}
        >
          {title}
        </Typography>
        {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
      </Box>

      <Box sx={{ minWidth: 0 }}>{children}</Box>
    </Paper>
  );
};
